import React from 'react';
import { OnboardingSource } from "../types.d";
import { usePaymentState } from "../../../../hooks/usePaymentState";
import PaymentWizard from './Pay360Wizard';

export default function Pay360Container() {
  const { paymentDetails } = usePaymentState();
  function renderBasedOnOnboardingSource() {
    const { onboardingSource } = paymentDetails;
    switch (onboardingSource) {
      case OnboardingSource.RMS:
        return <PaymentWizard inprogressHelperText={["payments.pay360.inprogressHelperText.content1"]} />
      case OnboardingSource.CARDSAVER:
        return <PaymentWizard inprogressHelperText={["payments.pay360.inprogressHelperText.content1"]} />
      case OnboardingSource.WORLDPAY:
          return <PaymentWizard
            inprogressHelperText={["payments.worldpay.content2","payments.pay360.inprogressHelperText.content1"]}
          />
      case OnboardingSource.BARCLAYCARD:
        return <PaymentWizard
          inprogressHelperText={["payments.barclaycard.content2","payments.pay360.inprogressHelperText.content1"]}
        />
      default:
        return null
    }
  }
  return (
    <main>
      {renderBasedOnOnboardingSource()}
    </main>
  )
}
